import { attributeCollectionTypes } from "components/PimDashboard/data";
import { arrType, createdByColumns, inputTypes, publishColumns, selectOptionsKeyName } from "data/globalData";
import { studioAttrValAssocObj } from "../StudioAttributes/data";

export const lsModalProfileFilterValStr = "modal_profile_table_filter_obj";

const withProfileFilterOptions = (row) => {
	if (!row) return row;
	if (row.input_type !== inputTypes.SELECT.key && row.input_type !== inputTypes.MULTIPLE_SELECT.key) return row;

	const linkedValues = row?.[studioAttrValAssocObj];
	const list = Array.isArray(linkedValues)
		? linkedValues.map((val) => ({ name: val?.value, key: val?.value }))
		: (row?.[selectOptionsKeyName]?.list ?? []);

	return {
		...row,
		[selectOptionsKeyName]: { type: arrType, list },
	};
};

export const getModalProfileFilterColumns = (allAttributes = []) => {
	const map = new Map();
	[
		...(allAttributes || []).filter((row) => row?.collection_type === attributeCollectionTypes.MODAL_PROFILES.key),
		...createdByColumns,
		...Object.values(publishColumns),
	].forEach((col) => {
		if (col?.key) map.set(col.key, withProfileFilterOptions(col));
	});
	return [...map.values()];
};
